import { __decorate } from "tslib";
import { Group } from 'three';
import { SaveChild } from '../../../Core/Save.js';
import { LinePointToPoint } from '../LinePointToPoint.js';
import { DraggableLabel } from './DraggableLabel.js';
export class LabelText extends Group {
    constructor(params) {
        super();
        this.name = params.name ?? 'LabelText';
        this.interceptedByRaycaster = true;
        this.add(this.label = new DraggableLabel(this.name, params.viewType, params.objToAnchor, params.anchor, params.labelParams, params.scaleFactor), this.line = new LinePointToPoint(this.name, params.color, this.label, params.objToAnchor));
        this.line.visible = false;
        this.label.bindEvent(['onHover', 'onLeave'], () => {
            this.line.visible = !this.line.visible;
        });
    }
    setParam(key, value) {
        this.label.setParam(key, value);
    }
    dispose() {
        super.dispose();
        this.label.dispose();
        this.line.dispose();
    }
}
__decorate([
    SaveChild()
], LabelText.prototype, "label", void 0);
//# sourceMappingURL=LabelText.js.map